import React from "react";
import { Link } from "react-router-dom";
import { Users, CreditCard, Activity, Server } from "lucide-react";
import { useOutletContext } from "react-router-dom";
import type { LucideIcon } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@pgs-core/ui/components/card";
import { PageHeader } from "@pgs-core/ui/components/page-header";

interface DashboardClient {
  lifecycle?: string;
}

interface StatCardProps {
  title: string;
  value: React.ReactNode;
  description: string;
  icon: LucideIcon;
  href: string;
}

function StatCard({ title, value, description, icon: Icon, href }: StatCardProps) {
  return (
    <Link to={href}>
      <Card className="transition-colors hover:bg-muted/50">
        <CardHeader className="flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">{title}</CardTitle>
          <Icon className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{value}</div>
          <p className="text-xs text-muted-foreground">{description}</p>
        </CardContent>
      </Card>
    </Link>
  );
}

export function DashboardPage() {
  const { clients } = useOutletContext<{ clients: DashboardClient[] }>();

  const liveCount = clients.filter((c) => c.lifecycle?.toLowerCase() === "live").length;
  const provisioningCount = clients.filter(
    (c) => c.lifecycle?.toLowerCase() === "provisioning"
  ).length;

  return (
    <div>
      <PageHeader
        title="Dashboard"
      />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard
          title="Total Clients"
          value={clients.length}
          description={`${liveCount} live, ${provisioningCount} provisioning`}
          icon={Users}
          href="/clients"
        />
        <StatCard
          title="Billing"
          value="—"
          description="Global billing overview"
          icon={CreditCard}
          href="/billing"
        />
        <StatCard
          title="Activity"
          value="—"
          description="Audit log and events"
          icon={Activity}
          href="/activity"
        />
        <StatCard
          title="Infrastructure"
          value="—"
          description="Global infrastructure status"
          icon={Server}
          href="/infrastructure"
        />
      </div>
    </div>
  );
}
